module.exports = __webpack_public_path__ + "img/fishing-640.af4ab1b8.jpg";